<template>
  <div
    ref="wrapup"
    class="wrapup no-scroll-tracks text-noselect"
    tabindex="1"
    autofocus
    @scroll="handleScroll"
    @wheel="handleWheel"
    @touchstart="swpHandleTouchStart"
    @touchmove="swpHandleTouchMove"
    @touchend="e => swpHandleTouchEnd(e)"
    @keyup.up="swpDown"
    @keyup.down="swpUp"
    @mouseenter="
      () => {
        if ($refs.wrapup) {
          $refs.wrapup.focus()
        }
      }
    "
  >
    <div
      class="wrapup_header f-center text-nowrap anim-fade-in_slow font-inter"
      style="gap: 0.75em; z-index: 5; font-size: clamp(1px, 1.25em, 3vw)"
      :class="{
        wrapup_header_ontop: visibleSectionIdx !== 0,
      }"
    >
      <router-link :to="{ name: links_menu[0].pathName }">
        <NavCard
          :item="links_menu[0]"
          class="navcard_menu navcard_menu-trigger font-eina02 hover_lighted"
          :style="`
            --icon-size: 2rem;
            --title-size: inherit;
            --padding: 0 0.75em;
            --title-weight: 700;
            --clr-text:var(--clr-white-0);
            --clr-text-active:var(--clr-white-0);
            --clr-text-hover:var(--clr-white-0);
            --clr-back:transparent;
            --clr-back-active:transparent;
            --clr-back-hover:transparent;
            --title-transform: normal;
            `"
        >
          <template #icon>
            <Logo style="fill: var(--clr-primary)" />
          </template>
        </NavCard>
      </router-link>

      <div
        class="bl-grey"
        style="height: clamp(1px, 2em, 4vw)"
      ></div>

      <div
        class="wrapup_header_right d-flex weight_700 uppercase"
        style="padding: 0 0.75em"
      >
        <div class="clr-grey">2023</div>
        <div class="clr-white ml-2">Wrap-up</div>
      </div>
    </div>

    <LoaderCircles
      v-if="wrapup_call.loading"
      class="loader_wrapup anim-fade-in_slow"
      style="
        --size: clamp(1px, 12em, 12vw);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    />

    <IconAndText
      v-else-if="wrapup_call.error"
      icon="mdi-alert-circle-outline"
      class="pa-8"
      style="
        --icon-size: clamp(1px, 12em, 12vw);
        --icon-color: var(--clr-error);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
      :title="$t('messages.oops_error')"
      :subtitle="$t('messages.opps_error_sub')"
    >
    </IconAndText>

    <div v-else>
      <div
        v-for="(item, idx) in sections"
        :ref="`wrapup_scrollsection_${idx}`"
        :key="item.id"
        class="wrapup_scrollsection"
      >
        <section
          :style="`--opacity:${visibleSectionIdx === idx ? 1 : 0}`"
          class="wrapup_section"
          :class="[{ backgreen: item.backgreen }, { slideelements: visibleSectionIdx === idx }]"
        >
          <FollowCursorBox
            v-if="item.hiddenText"
            class="hiddentext"
            :speedIn="20"
            :speedOut="33"
            style="position: absolute; height: 100%; width: 100%; z-index: 9"
          >
            <template #default="{ coordinates, mousedownMs }">
              <div
                class="hiddentext_text f-center text-nowrap"
                style="height: 100%; width: 100%"
                :style="`

                font-weight: 700;
                font-size: ${(globals_window_size.width / item.hiddenText.length) * 1.25 || 1}px;
                --clrdot:${item.clrdot || 'var(--clr-primary)'};
                --background-position:${coordinates.x_px - (mousedownMs + 44) / 2}px ${
                  coordinates.y_px - (mousedownMs + 44) / 2
                }px;
                --size: ${mousedownMs + 44}px ${mousedownMs + 44}px;
                z-index: ${mousedownMs ? 9 : 0};
                `"
              >
                <!-- <span style="position: relative; z-index: 1"> -->
                {{ item.hiddenText }}
                <!-- </span> -->
              </div>
              <div
                class="hiddentext_dot"
                style="position: absolute; z-index: 9"
                :style="`
                --clrdot:${item.clrdot || 'var(--clr-primary)'};
                --size: 12px;
                left: ${coordinates.x_px - 6}px;
                top: ${coordinates.y_px - 6}px;
          `"
              ></div>
            </template>
          </FollowCursorBox>

          <div
            v-if="item.outro"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="wrapup_section_intro flex-1 f-column f-center text-center"
              style="gap: 3em"
            >
              <h1 class="uppercase anim-fade-in">
                We wish you
                <span
                  class="text-nowrap"
                  :class="{ 'anim-underline': visibleSectionIdx === idx }"
                >
                  <span class="anim-underline_text"> all the luck</span>
                </span>
                in 2024.
              </h1>
              <h2 class="slideinleft mt-8">
                <span class="text-nowrap"> Thank you </span> for being with us
                <span class="text-nowrap"> in 2023</span>
              </h2>

              <div class="text-large slideinleft">
                Read more about the past year in GTO Wizard
                <a
                  href="https://blog.gtowizard.com/gto-wizard-2023-wrapup/"
                  class="text-underline hover_lighted clr-primary"
                  >here</a
                >.
              </div>

              <div
                class="clr-grey bt-grey slideinleft pt-8 mt-auto f-column"
                style="max-width: clamp(1px, 52em, calc(100vw - 8em)); line-height: 1.4"
              >
                <div>
                  Would you like to see more detailed overview next year? <br />
                  Let us know in our
                  <a
                    href="https://discord.gg/ht3QxrP"
                    class="text-underline hover_lighted clr-primary"
                    >Discord</a
                  >
                  community with any ideas on what would be nice to see here next time.
                </div>
                <div class="f-center f-wrap mx-auto mt-4">
                  <a
                    v-for="item in socials"
                    :key="item.id"
                    :title="item.name"
                    class="mdi text-big icon_btn clr-grey pa-2 clr-hover"
                    style="--clr-hover: var(--clr-primary)"
                    :class="item.icon"
                    :href="item.href"
                    target="_blank"
                  ></a>
                </div>
                <div class="anim-fade-in_delayed_2s d-flex mx-auto mt-8">
                  <div
                    class="clr-primary uppercase weight_500 f-center text-nowrap"
                    style="font-size: clamp(1px, 1.25rem, 6vw)"
                  >
                    <i class="clr-primary mdi mdi-chevron-left my-auto line-height_1"></i>
                    <router-link
                      data-tst="link_to_dashboard"
                      :to="{ name: 'Dashboard' }"
                      class="link-underline link-underline_hover cursor-pointer"
                      v-html="$t('subscription.continue_to_dashboard')"
                    >
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="item.intro"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="wrapup_section_intro f-column f-center text-center"
              style="gap: 3em"
            >
              <h1 class="slideinleft">The yearly wrapup of 2023</h1>
              <div
                class="clr-grey slideinleft text-large mt-4"
                style="
                  max-width: clamp(1px, 52em, calc(100vw - 8em));
                  line-height: 1.4;
                  font-size: clamp(1px, 1.75rem, 4vw);
                "
              >
                Check out your year in review with GTO Wizard!
                <br />
                Review your stats and share your progress with friends.
              </div>

              <div
                v-if="item.incomplete"
                class="bt-grey pt-12 mt-12 anim-fade-in_delayed_1s"
              >
                <GwMessage
                  :message="{
                    hide: true,
                    icon: 'mdi-progress-alert',
                    type: 'info',
                    text: 'Some stats are incomplete. But you can still check out the presentation!',
                  }"
                  style="font-size: clamp(1px, 1.5rem, 4vw); text-align: left"
                >
                </GwMessage>
              </div>
            </div>
          </div>

          <!-- MAYBE intro -->
          <div
            v-else-if="item.intro_practice"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="wrapup_section_intro f-column f-center text-center"
              style="gap: 3em"
            >
              <h2 class="slideinleft">In 2023 you practiced</h2>
              <h1 class="slideinleft">
                {{ numKtoM(item.intro_practice.numHands || 0, 1000, 2) }}
                {{ item.intro_practice.numHands === 1 ? 'hand' : 'hands' }}
              </h1>
              <div
                class="clr-grey slideinleft text-large"
                style="
                  max-width: clamp(1px, 52em, calc(100vw - 8em));
                  line-height: 1.4;
                  font-size: clamp(1px, 1.5rem, 4vw);
                "
              >
                Check out your year in review with GTO Wizard!
                <br />
                Review your stats and share your progress with friends.
              </div>
            </div>
          </div>
          <div
            v-else-if="item.intro_hands"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="wrapup_section_intro f-column f-center text-center"
              style="gap: 3em"
            >
              <h2 class="slideinleft">In 2023 you uploaded</h2>
              <h1 class="slideinleft">
                {{ numKtoM(item.intro_hands.numHands || 0, 1000, 2) }}
                {{ item.intro_hands.numHands === 1 ? 'hand' : 'hands' }}
              </h1>
              <div
                class="clr-grey slideinleft text-large"
                style="
                  max-width: clamp(1px, 52em, calc(100vw - 8em));
                  line-height: 1.4;
                  font-size: clamp(1px, 1.5rem, 4vw);
                "
              >
                Check out your year in review with GTO Wizard!
                <br />
                Review your stats and share your progress with friends.
              </div>
            </div>
          </div>

          <div
            v-if="item.tag"
            class="wrapup_tag anim-fade-in_slow"
            :style="item.tag.style"
          >
            {{ item.tag.text }}
          </div>
          <div
            v-if="item.box"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="slideinleft text-center section-title"
              v-html="item.box.title"
            ></div>
            <WrapupBox
              class="slideinleft"
              style="width: 100vw; max-width: clamp(1px, 44rem, calc(100vw - 4em))"
              :box="item.box"
              :style="item.box.style"
            >
              <template
                v-if="item.box.placeholder"
                #default
              >
                <div
                  class="text-large text-center clr-grey weight_500"
                  v-html="item.box.placeholder"
                ></div>
              </template>
            </WrapupBox>
          </div>
          <div
            v-if="item.cards"
            class="wrapup_section_box_wrapper"
          >
            <div
              class="slideinleft text-center section-title"
              v-html="item.cards.title"
            ></div>

            <WrapupBox
              class="slideinleft"
              style="width: 100vw; max-width: clamp(1px, 44rem, calc(100vw - 4em))"
              :style="item.cards.style"
            >
              <div
                v-if="item.cardTag"
                class="card-tag"
                :style="item.cardTag.style"
                v-html="item.cardTag.text"
              ></div>
              <div
                class="d-flex f-wrap"
                style="gap: 2rem"
              >
                <CardRow
                  :cards="item.cards.cards || 'EeEe'"
                  cardStyle="--height: 11.6em; margin: 0 0.5rem; gap: 0.5em; --value-size-increase: 6"
                  size="large"
                />
                <div class="mt-auto">
                  <h4>Has been dealt</h4>
                  <h2 class="mt-2">
                    {{ numKtoM(item.cards.hands_count || 0, 1000, 2) }}
                    times
                  </h2>
                </div>
              </div>
            </WrapupBox>
          </div>
          <div
            v-else-if="item.overview"
            class="wrapup_section_box_wrapper"
            style="gap: 3rem; width: clamp(1px, 120rem, calc(100vw - 4rem))"
          >
            <div
              class="slideinleft text-center section-title"
              v-html="'Overview'"
            ></div>
            <div class="d-flex f-wrap w-100">
              <div
                v-for="(oo, idx) in [
                  {
                    title: 'trainer',
                    sections: sections.filter(
                      i => !i.overviewHidden && i.tag && i.tag.id === 'trainer',
                    ),
                  },
                  {
                    title: 'uploads',
                    sections: sections.filter(
                      i => !i.overviewHidden && i.tag && i.tag.id === 'uploads',
                    ),
                  },
                ]"
                :key="`overviewgrid_${idx}`"
                class="f-center flex-1 f-column mb-auto"
              >
                <div
                  class="slideinleft text-center wrapup_tag"
                  style="position: relative; margin: 2rem 0 1rem 0; z-index: 1"
                  :style="oo.sections[0].tag.style"
                  v-html="oo.sections[0].tag.text"
                ></div>

                <div class="overviewgrid">
                  <WrapupBox
                    v-for="(ii, idx) in oo.sections.filter(i => !!(i.box || i.cards))"
                    :key="`last_${idx}`"
                    :box="ii.box"
                    class="slideinleft h-100s overviewgrid_item"
                    :style="ii.box ? ii.box.style : item.cards ? item.cards.style : ''"
                    style="--padding: 1em 1.75em"
                  >
                    <div
                      v-if="ii.cards"
                      class="d-flex f-wrap"
                      style="gap: 2rem"
                    >
                      <CardRow
                        :cards="ii.cards.cards || 'EeEe'"
                        cardStyle="--height: clamp(1px, 9.5em, 10vw); margin: 0 0.25rem; gap: 0.5em; --value-size-increase:4.75"
                        size="large"
                        class="mx-auto"
                      />
                      <!-- <div class="mt-auto">
                        <h4>Has been dealt</h4>
                        <h2 class="mt-2">
                          {{ numKtoM(ii.cards.hands_count || 0, 1000, 2) }}
                          times
                        </h2>
                      </div> -->
                    </div>
                  </WrapupBox>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div
        v-if="globals_window_size.width > 720"
        class="anim-fade-in_delayed_1s d-flex arrows_wrapup"
        style="
          z-index: 6;
          bottom: 3em;
          position: fixed;
          left: 50%;
          transform: translateX(-50%);
          gap: 1rem;
        "
      >
        <GwTooltip
          v-for="item in [
            {
              icon: 'mdi-arrow-up',
              idx: visibleSectionIdx - 1,
              tooltip: `Previous <span class='keyboardkey_key clr-white mdi-arrow-up mdi'></span>`,
              disabled: visibleSectionIdx === 0,
            },
            {
              icon: 'mdi-arrow-down',
              idx: visibleSectionIdx + 1,
              tooltip: `Next <span class='keyboardkey_key clr-white mdi-arrow-down mdi'></span>`,
              disabled: visibleSectionIdx === sections.length - 1,
            },
          ]"
          :key="item.icon"
          :tooltip="item.tooltip"
          placement="bottom"
          tooltipCssStyle="font-size:0.875rem;  font-weight:500; whites-space:nowrap;border-radius:8px;"
          :class="{
            'no-events opacity_5': item.disabled,
          }"
          @click="scrollToSection(item.idx)"
        >
          <template #opener>
            <div
              class="icon_btn clr-hover mdi mdi-arrow-down mt-auto hover_scales"
              :class="item.icon"
              style="
                font-size: 2em;
                padding: 0.75rem;
                color: var(--clr-black-5);
                --clr-hover: var(--clr-primary);
                --clr-back: rgba(7, 110, 91, 0.25);
                --after-radius: 50%;
                border: solid currentColor 1px;
              "
              @click="scrollToSection(visibleSectionIdx + 1)"
            ></div>
          </template>
        </GwTooltip>
      </div>
      <div class="wrapup_scroll">
        <GwTooltip
          v-for="(item, idx) in sections.filter(i => !i.hiddenInNav)"
          :key="idx"
          :tooltip="item.title"
          :placement="mobile ? 'top' : 'left'"
          tooltipCssStyle="font-size:1rem; padding:0.5rem 0.75rem; font-weight:500; whites-space:nowrap;border-radius:99px;"
          @click="scrollToSection(item.id)"
        >
          <template #opener>
            <div
              class="wrapup_scroll_dot"
              :class="{
                wrapup_scroll_dot_active: visibleSectionIdx === item.id,
              }"
              @click="scrollToSection(item.id)"
            ></div>
          </template>
        </GwTooltip>
      </div>
    </div>

    <!-- <div class="shadow_back"></div> -->
  </div>
</template>

<script>
import Logo from '@/assets/logo.svg'
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'
import links_mix from '@/mixins/links_mix'
import screen_mix from '@/mixins/screen_mix'
import swipe_mix from '@/mixins/swipe_mix'
import GwTooltip from '@/components/lib/GwTooltip'
import LoaderCircles from '@/components/Loaders/LoaderCircles'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import CardRow from '@/components/CardRow/CardRow'
import FollowCursorBox from '@/components/lib/FollowCursorBox'
import GwMessage from '@/components/Messages/GwMessage'
import WrapupBox from './WrapupBox'

export default {
  name: 'Wrapup2023',
  components: {
    Logo,
    WrapupBox,
    GwTooltip,
    LoaderCircles,
    IconAndText,
    CardRow,
    FollowCursorBox,
    GwMessage,
  },
  mixins: [fetch_mix, links_mix, format_mix, screen_mix, swipe_mix],
  data() {
    return {
      wrapup_call: {
        conf: {
          endpoint: 'poker/year-summary/2023/',
          apiVersion: 'v1',
        },
        loading: false,
        loaded: false,
        status: 0,
      },
      visibleSectionIdx: -1,
      sections: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      const maxScrollTop = scrollHeight - clientHeight
      const ll = this.sections.length
      const sectionHeight = maxScrollTop / ll
      const sectionIndex = Math.floor(scrollTop / sectionHeight)
      this.visibleSectionIdx = sectionIndex >= ll ? ll - 1 : sectionIndex
    },
    handleWheel(e) {
      if (this.$refs.wrapup) {
        this.$refs.wrapup.scrollTop += e.deltaY
      }
    },
    swpUp() {
      this.scrollToSection(this.visibleSectionIdx + 1)
    },
    swpDown() {
      this.scrollToSection(this.visibleSectionIdx - 1)
    },
    scrollToSection(idx) {
      idx = idx < 0 ? (idx > this.sections.length - 1 ? this.sections.length - 1 : 0) : idx
      const el = this.$refs[`wrapup_scrollsection_${idx}`]
      if (this.$refs.wrapup && el?.[0]) {
        const { offsetTop } = el[0]
        this.$refs.wrapup.scrollTop = offsetTop
      }
    },
    async getData() {
      const { data, error } = await this.fch_getData(this.wrapup_call)
      if (error) {
        return
      }

      // console.log(data)
      // this.data = data || {}
      // LUCKY, UNLUCKY
      // total_time_parsed seconds

      // Lucky / Unlucky only
      const cardsTags = {
        LUCKY: {
          text: 'Lucky',
          tooltip: 'You had dealers in your favor',
          style: '--clr-tag: var(--clr-primary)',
        },
        MEDIOCRE: {
          text: 'Unlucky',
          tooltip: 'Seems the dealer did not like you that much',
          style: '--clr-tag: var(--clr-error)',
        },
        UNLUCKY: {
          text: 'Unlucky',
          tooltip: 'Seems the dealer did not like you that much',
          style: '--clr-tag: var(--clr-error)',
        },
      }

      // data = {
      //   total_practice: 660,
      //   favorite_drill: {
      //     id: '74b36cd8-9f7a-4cc1-ab76-8bf50834c168',
      //     name: 'VS OPEN (WEAKNESSES)',
      //     hands_count: 4,
      //   },
      //   gto_score: 0.0152017807303312,
      //   total_hands: 8136,
      //   total_time_parsed: 110492,
      //   total_amount_won: [
      //     { currency: 'CHIPS', amount: 8272.82 },
      //     { currency: 'USD', amount: 3595.96 },
      //   ],
      //   most_frequent_opponent: { name: 'e6d5edc0__ooooooooo__ssssss', hands_count: 54 },
      //   most_frequent_hand: { hand: 'AdJd', simple_hand: 'AJs', hands_count: 16 },
      //   most_frequent_hand_group: 'LUCKY',
      //   // most_frequent_hand_group: 'UNLUCKY',
      // }

      const amountWon =
        (
          data.total_amount_won.find(i => i.currency !== 'CHIPS') ||
          data.total_amount_won.find(i => i.currency === 'CHIPS')
        )?.amount || 0

      // amountWon = -1

      const trainer = {
        id: 'trainer',
        style: '--clr-tag:var(--clr-blue)',
        text: 'Practiced hands',
      }
      const uploads = {
        id: 'uploads',
        style: '--clr-tag:var(--clr-yellow)',
        text: 'Analyzed hands',
      }

      this.sections = [
        {
          hiddenText: 'Hello Wizard',
          title: 'Intro',
          intro: {},
          backgreen: true,
          incomplete:
            !data.total_practice || !data.total_hands || !data.favorite_drill?.hands_count,
          // hiddenInNav: true,
        },
        {
          hiddenText: 'Mastery requires repetition',
          title: 'Practiced hands',
          tag: trainer,
          box: {
            title: 'You practiced',
            subtitle: 'Practiced hands',
            icon: 'mdi-google-controller',
            text: `${this.numKtoM(data.total_practice || 0, 10000, 1)} ${
              data.total_practice === 1 ? 'hand' : 'hands'
            }`,
            iconColor: 'var(--clr-blue)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-blue)',
            },
          },
        },
        {
          hiddenText: `Data interprets reality`,
          title: 'GTO Score',
          tag: trainer,
          box: {
            title: 'Your average <span class="text-nowrap">GTO score</span>',
            subtitle: 'GTO Score',
            icon: 'mdi-finance',
            text: `${this.numFixed((data.gto_score || 0) * 100, 1)}%`,
            iconColor: 'var(--clr-primary)',
            style: {
              '--clr-1': 'var(--clr-blue)',
              '--clr-2': 'var(--clr-primary)',
            },
          },
        },
        {
          hiddenText: 'Practice makes perfect',
          title: 'Most frequent drill',
          tag: trainer,
          box: {
            title: 'Most frequent <span class="text-nowrap">drill</span>',
            subtitle: 'Favorite drill',
            icon: 'mdi-target',
            placeholder: !data.favorite_drill?.name
              ? 'You have not used drills at all in 2023. </br> To elevate your performance, start using drills in your practice.'
              : '',
            text: `${data.favorite_drill?.name || '-'}`,
            iconColor: 'var(--clr-mtt)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-mtt)',
            },
          },
          overviewHidden: !data.favorite_drill?.name,
          // isHidden: !data.favorite_drill?.hands_count,
        },
        {
          hiddenText: 'Persistence perfects practice',
          title: 'Favorite drill',
          tag: trainer,
          box: {
            title: 'You have drilled it',
            subtitle: 'Favorite drill',
            icon: 'mdi-target',
            text: `${this.numKtoM(data.favorite_drill?.hands_count || 0, 10000, 1)} times`,
            iconColor: 'var(--clr-mtt)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-mtt)',
            },
          },
          isHidden: !data.favorite_drill?.hands_count,
        },
        {
          hiddenText: 'Stay Balanced',
          title: 'Uploaded hands',
          tag: uploads,
          box: {
            title: 'Uploaded hands',
            subtitle: 'Uploaded hands',
            icon: 'mdi-cards-playing',
            text: this.numKtoM(data.total_hands || 0, 10000, 1),
            iconColor: 'var(--clr-yellow)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-yellow)',
            },
          },
        },
        {
          hiddenText: cardsTags[data.most_frequent_hand_group]?.tooltip || 'Game of chance',
          title: 'Most common hand',
          tag: uploads,
          cardTag: cardsTags[data.most_frequent_hand_group] || null,
          cards: {
            title: 'Most common hand',
            cards: data.most_frequent_hand?.hand || 'EeEe',
            hands_count: this.numKtoM(data.most_frequent_hand?.hands_count || 0, 10000, 1),
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-primary)',
            },
          },
          isHidden: !data.most_frequent_hand?.hand,
        },
        {
          hiddenText: 'Achievements crown efforts',
          title: `Net ${amountWon >= 0 ? 'profit' : 'loss'}`,
          tag: uploads,
          box: {
            title: `Net ${amountWon >= 0 ? 'profit' : 'loss'}`,
            subtitle: 'Amount won',
            icon: 'mdi-currency-usd',
            text: `$ ${this.numKtoM(amountWon || 0, 10000, 1)}`,
            iconColor: amountWon >= 0 ? 'var(--clr-primary)' : 'var(--clr-error)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': amountWon >= 0 ? 'var(--clr-primary)' : 'var(--clr-error)',
            },
          },
          isHidden: !data.most_frequent_hand?.hand || amountWon <= 0,
        },
        {
          hiddenText: 'Rivals inspire excellence',
          title: 'Most frequent opponent',
          tag: uploads,
          box: {
            title: 'Most frequent opponent',
            subtitle: 'Opponent',
            icon: 'mdi-account-circle',
            text: data.most_frequent_opponent?.name || '-',
            iconColor: 'var(--clr-error)',
            style: {
              '--clr-1': 'var(--clr-primary)',
              '--clr-2': 'var(--clr-error)',
            },
          },
          isHidden: !data.most_frequent_hand?.hand,
        },
        {
          hiddenText: 'When life gives you lemons...',
          title: 'Overview',
          overview: true,
          isHidden: this.globals_window_size.width < 1333 || this.globals_window_size.height < 855,
        },
        {
          // hiddenText: 'Stay GTO',
          title: 'Outro',
          // hiddenInNav: true,
          outro: {},
          backgreen: true,
        },
      ]
        .filter(i => !i.isHidden)
        .map((i, idx) => ({
          ...i,
          id: idx,
        }))

      // console.log(this.sections)
      // console.log(
      //   this.sections.map(i => ([
      //     title: i.title,
      //     hiddenText: i.hiddenText,
      //   ]),
      // )
      this.visibleSectionIdx = 0
    },
  },
  computed: {
    socials() {
      return [
        {
          hidden: this.$i18n.locale !== 'zh',
          id: 'wechat',
          icon: 'mdi-wechat',
          name: 'WeChat',
          href: 'https://mp.weixin.qq.com/s/-O_oy8xPsyEN7ZisOhLn7w',
        },
        {
          hidden: this.$i18n.locale !== 'zh',
          id: 'bilibili',
          icon: 'gw-icon-bilibili ',
          name: 'Bilibili',
          href: 'https://space.bilibili.com/1776741195',
        },
        {
          id: 'facebook',
          icon: 'mdi-facebook',
          name: 'Facebook',
          href: 'https://www.facebook.com/GTOWizard/',
        },
        {
          id: 'instagram',
          icon: 'mdi-instagram',
          name: 'Instagram',
          href: 'https://www.instagram.com/gtowizard/',
        },
        {
          id: 'twitter',
          icon: 'mdi-twitter',
          name: 'Twitter',
          href: 'https://twitter.com/gtowizard',
        },
        {
          hidden: this.$i18n.g1,
          id: 'youtube',
          icon: 'mdi-youtube',
          name: 'Youtube',
          href: 'https://www.youtube.com/@GTOWizard',
        },
        {
          hidden: this.$i18n.g1,
          id: 'twitch',
          icon: 'mdi-twitch',
          name: 'Twitch',
          href: 'https://www.twitch.tv/gtowizardtv',
        },
        {
          id: 'discord',
          icon: 'mdi-discord',
          name: 'Discord',
          href: this.links_url_links.discord_invite_link.url,
        },
      ].filter(i => !i.hidden)
    },
  },
}
</script>
<style lang="scss" scoped>
.hiddentext {
  // cursor: none;
  // border: solid red 1px;
  // &:active {
  // .hiddentext_dot {
  // opacity: 0;
  // transition: opacity 0.44s;
  // }
  // }
  &_text {
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    --clrdot: red;
    background-image: radial-gradient(var(--clrdot), transparent 10%);
    background-position: var(--background-position, 50% 50%);
    background-size: var(--size, 100px 100px);
    // font-size: 44rem;
    // color: rgba(7, 110, 91, 0.125);
  }
  &_dot {
    --size: 32px;
    width: var(--size);
    height: var(--size);
    // background: var(--clrdot);
    background-image: radial-gradient(var(--clrdot), transparent);
    border-radius: 50%;
    z-index: 2;
    position: absolute;
  }
}

h1 {
  font-size: clamp(1px, 4.5em, 8vw);
  font-weight: 700;
  line-height: 1.2;
}
.section-title {
  font-size: clamp(1px, 3.5em, 7vw);
  font-weight: 700;
  line-height: 1.2;
}
h2 {
  font-size: clamp(1px, 2.5em, 6vw);
  font-weight: 700;
  line-height: 1.2;
}
h3 {
  font-size: 2em;
  font-weight: 700;
  line-height: 1.2;
}
h4 {
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1.2;
}

.wrapup_tag {
  font-weight: 500;
  line-height: 1.2;
  padding: 1em 2em;
  margin: -3rem 0 3rem 0;
  border-radius: 99px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: var(--clr-tag);
  z-index: 5;
  &::before {
    content: '';
    background: var(--clr-tag);
    opacity: 0.125;
    position: absolute;
    border-radius: 99px;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
}

.card-tag {
  font-weight: 500;
  line-height: 1.2;
  padding: 0.5rem 2rem;
  border-radius: 99px;
  font-size: 1.25rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  color: var(--clr-tag);
  z-index: 5;
  &::before {
    content: '';
    background: var(--clr-tag);
    opacity: 0.125;
    position: absolute;
    border-radius: 99px;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
}

.wrapup {
  font-family: 'Poppins', sans-serif;
  font-size: clamp(1px, 1rem, 8vw);
  // text-align: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  width: 100vw;
  .backgreen {
    background: linear-gradient(
      45deg,
      var(--clr-black-0),
      var(--clr-black-0),
      rgba(7, 110, 91, 0.125),
      var(--clr-black-0-2),
      var(--clr-black-0-2)
    );
  }
  &_header {
    --top: 10%;
    border-radius: 99px;
    padding: 1em;
    background: linear-gradient(var(--clr-black-0-1), var(--clr-black-1));
    border: solid var(--clr-black-2) 1px;
    position: fixed;
    left: 50%;
    top: var(--top);
    transition: 0.66s ease;
    transform: translateX(-50%);
    &_ontop {
      --top: 1em;
      background: transparent;
      border: solid transparent 1px;
    }
    &:hover {
      background: linear-gradient(var(--clr-black-0-1), var(--clr-black-1));
      border: solid var(--clr-black-2) 1px;
    }
  }
  &_scrollsection {
    flex: 1;
    min-height: 100vh;
    min-width: 100vw;
    position: relative;
  }
  &_section_box_wrapper {
    padding: 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5rem;
  }
  &_section {
    z-index: 4;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    --opacity: 0;
    opacity: var(--opacity);
    z-index: var(--opacity);
    transition: 0.22s ease;
  }
  &_scroll {
    position: fixed;
    z-index: 6;
    display: flex;
    flex-direction: column;
    align-items: center;
    // background: red;
    gap: 1em;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    &_dot {
      --size: 1.5em;
      width: var(--size);
      height: var(--size);
      background: var(--clr-black-1);
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.2s ease;
      &_active {
        background: var(--clr-black-3);
      }
      &:hover {
        background: var(--clr-black-3);
      }
    }
  }
}

.shadow_back {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border-radius: 50%;
  background: blue;
  box-shadow:
    0 0 60px 30px red,
    0 0 100px 60px blue,
    0 0 140px 90px blue;
  position: fixed;
  top: 50%;
  left: 50%;
  transition: 0.44s ease;
  animation: MoveAround 12s infinite;
  // animation: MoveAround 3s infinite;
}

@keyframes MoveAround {
  0% {
    transform: translate(10vh, 20vw) scale(1.3);
  }
  25% {
    transform: translate(-22vh, -11vw) scale(1.5);
  }
  44% {
    transform: translate(-44vh, -11vw) scale(2);
  }
  50% {
    transform: translate(0vh, -66vw) scale(2);
  }
  75% {
    transform: translate(44vh, 11vw) scale(1.7);
  }
  100% {
    transform: translate(10vh, 44vw) scale(1.3);
  }
}

.hover_scale {
  transition: 0.22s ease;
  &:hover {
    transform: scale(1.1);
  }
}

.slideelements {
  .slideinleft {
    animation-name: slideFromRight;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-timing-function: ease;
    &:nth-child(1) {
      animation-delay: 0.25s;
    }
    &:nth-child(2) {
      animation-delay: 0.5s;
    }
    &:nth-child(3) {
      animation-delay: 0.75s;
    }
    &:nth-child(4) {
      animation-delay: 1s;
    }
    &:nth-child(5) {
      animation-delay: 1.25s;
    }
    &:nth-child(6) {
      animation-delay: 1.5s;
    }
    &:nth-child(7) {
      animation-delay: 1.75s;
    }
    &:nth-child(8) {
      animation-delay: 2s;
    }
  }
  @keyframes slideFromRight {
    0% {
      transform: translateX(-10%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

.loader_wrapup {
  --color: var(--clr-black-6);
  animation: ChangeColor 12s infinite;
  @keyframes ChangeColor {
    0% {
      --color: var(--clr-black-1);
    }
    25% {
      --color: var(--clr-primary);
    }
    50% {
      --color: var(--clr-mtt);
    }
    75% {
      --color: var(--clr-blue);
    }
    100% {
      --color: var(--clr-black-2);
    }
  }
}

.overviewgrid {
  // display: grid;
  // grid-template-columns: repeat(3, 1fr);
  padding: 1rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.75rem;
  width: 100%;
  &_item {
    // done like this coz Safari fucks up grid and shadows
    margin: 1rem;
    min-width: 40%;
    flex: 1;
  }
}

@media (max-width: 1023px) {
  .wrapup_tag {
    margin: -4rem 0 2rem 0;
  }
  .wrapup_scroll {
    top: unset;
    right: unset;
    bottom: 3rem;
    flex-direction: row;
    left: 50%;
    transform: translateX(-50%);
    z-index: 8;
    &_dot {
      --size: 1.5em;
    }
  }
}

// @media (max-width: 720px) {
//   .arrows_wrapup {
//     display: none !important;
//   }
// }

@media (pointer: coarse) {
  .hiddentext_dot {
    display: none;
  }
}
</style>
